/* ============================================================
   NORTHSHEEP — hover a size, see that size's price

   Sizes here are priced individually, so a card that says only "From €44,95"
   leaves the shopper to click through to learn what the XXL costs. Hovering
   (or tabbing to) a size pill now swaps the card's price line for that
   variant's own price, and leaving puts the original back untouched.

   Works on both places a pill appears:
     .ns-card-sizes__pill  on a product card  -> the card's .price
     .ns-promo__variant    on an in-grid promo -> .ns-promo__price

   Delegated from document, because the collection grid is replaced wholesale
   by the Section Rendering API on every sort, filter and page change — a
   listener bound to a pill would be gone after the first sort. Nothing is
   remembered between hovers except the markup that was there to begin with,
   stored on the price element itself, so a re-render simply starts over.
   ============================================================ */
(function () {
  'use strict';
  if (window.__nsVariantPrice) return;
  window.__nsVariantPrice = true;

  var SOURCES = [
    { pill: '.ns-card-sizes__pill', scope: '.card-wrapper, .grid__item', price: '.price' },
    { pill: '.ns-promo__variant', scope: '.ns-promo', price: '.ns-promo__price' },
  ];

  /* The caption under the size row, in the Rail and Squares designs. The chip
     shows "XL"; this line says what an XL actually is. It moves with the
     price, so the card always reads as one answer rather than a size here and
     a number there. */
  function caption(hit) {
    var el = hit.pill.closest('.card-wrapper, .grid__item');
    if (!el) return;
    var cap = el.querySelector('[data-ns-size-caption]');
    if (!cap) return;
    // Calm cards carry the caption without the code ("ca. 110 cm"): the chip already says "L".
    var label = hit.pill.getAttribute('data-ns-vcap') || hit.pill.getAttribute('data-ns-vlabel');
    if (label) cap.textContent = label;
  }

  /* Calm cards: the reduction of the chosen size as "−8 %" next to the price (snippets/price.liquid prints the
     empty holder when the card asks for it). A size that is not reduced empties it. */
  function percent(hit) {
    var holder = hit.price && hit.price.querySelector('[data-ns-pct]');
    if (!holder) return;
    var pct = hit.pill.getAttribute('data-ns-vpct');
    holder.textContent = pct ? '−' + pct + ' %' : '';
  }

  /* The set prices under the sale badge ("2 for €79,95", ns-set-badges) move
     with a size-family pill (owner, 28 Sep 2026): the New Zealand skins are
     two products with their own sets, so the 100 cm sets must not stay on a
     card that now quotes the large skin. Only pills carrying data-ns-vsets;
     an empty value means that size has none. */
  function sets(hit) {
    var list = hit.pill.getAttribute('data-ns-vsets');
    if (list === null) return;
    var el = hit.pill.closest('.card-wrapper, .grid__item');
    if (!el) return;
    var texts = list.split('|').filter(function (t) {
      return t.trim() !== '';
    });
    var boxes = el.querySelectorAll('.card__badge');
    for (var i = 0; i < boxes.length; i++) {
      var old = boxes[i].querySelectorAll('.ns-set-badge');
      for (var j = 0; j < old.length; j++) old[j].remove();
      for (var k = 0; k < texts.length; k++) {
        var s = document.createElement('span');
        s.className = 'badge ns-set-badge';
        s.textContent = texts[k].trim();
        boxes[i].appendChild(s);
      }
    }
  }

  function match(target) {
    for (var i = 0; i < SOURCES.length; i++) {
      var pill = target.closest ? target.closest(SOURCES[i].pill) : null;
      if (!pill || !pill.getAttribute('data-ns-vprice')) continue;
      var scope = pill.closest(SOURCES[i].scope);
      if (!scope) continue;
      var price = scope.querySelector(SOURCES[i].price);
      if (!price) continue;
      return { pill: pill, price: price, kind: SOURCES[i].pill };
    }
    return null;
  }

  /* FILL THE CARD'S OWN MARKUP. DO NOT BUILD NEW MARKUP.

     This used to write its own price block, in Dawn's classes. It still came
     out looking different — the old price grey and small where the card's own
     was black, the new price charcoal where the card's was walnut — because
     the card's styling depends on more than those classes: which block Dawn
     renders, the `price--on-sale` flag on the wrapper, and several
     !important rules further up the sheet.

     So nothing is built now. Dawn renders BOTH a regular and a sale block in
     every price and hides one; this flips `price--on-sale` to choose which,
     and writes the numbers into the elements already there. Whatever the
     card looks like, the hovered price looks the same. */
  function fill(el, selector, text) {
    var target = el.querySelector(selector);
    if (target) target.textContent = text;
    return !!target;
  }

  /* Hovering a size CHOOSES it. The mark moves with the price, and both stay
     where the shopper left them — pointing at a size and reading its price,
     then looking away, should not undo the answer. */
  var QUOTED = { '.ns-card-sizes__pill': 'ns-card-sizes__pill--quoted', '.ns-promo__variant': 'ns-promo__variant--quoted' };

  function mark(hit) {
    var cls = QUOTED[hit.kind];
    if (!cls) return;
    var row = hit.pill.parentElement;
    if (!row) return;
    var marked = row.querySelectorAll('.' + cls);
    for (var i = 0; i < marked.length; i++) marked[i].classList.remove(cls);
    hit.pill.classList.add(cls);
  }

  function show(e) {
    var hit = match(e.target);
    if (!hit) return;
    var el = hit.price;
    var now = hit.pill.getAttribute('data-ns-vprice');
    var was = hit.pill.getAttribute('data-ns-vwas');

    mark(hit);
    caption(hit);
    if (hit.kind === '.ns-card-sizes__pill') {
      sets(hit);
      percent(hit);
    }

    if (hit.kind === '.ns-promo__variant') {
      el.textContent = now;
      if (was) {
        var s = document.createElement('s');
        s.className = 'ns-promo__price-was';
        s.textContent = was;
        el.appendChild(s);
      }
      return;
    }

    if (was) {
      el.classList.add('price--on-sale');
      // Dawn's markup first, then recently viewed's own (it builds its cards
      // in JS and names the parts differently).
      fill(el, '.price__sale .price-item--sale', now) || fill(el, '.ns-rv__price-sale, .ns-rv__price-regular', now);
      // Dawn marks the struck price with <s> in some versions and a plain
      // span in others; take whichever this card actually has.
      fill(el, '.price__sale s, .price__sale .price-item--regular', was) || fill(el, '.ns-rv__price-compare', was);
    } else {
      el.classList.remove('price--on-sale');
      fill(el, '.price__regular .price-item--regular', now) ||
        fill(el, '.ns-rv__price-regular, .ns-rv__price-sale', now);
    }
  }

  /* NOTHING PUTS IT BACK.

     There was a restore on mouseout, which made this a preview: the price
     flicked to the size under the pointer and snapped back to the smallest
     one the moment the pointer moved away, so a shopper comparing sizes never
     had the answer in front of them long enough to act on it. Moving on is
     not the same as changing your mind. The choice stays until another size
     is chosen, or the grid re-renders and Liquid's own default comes back. */

  /* A MOUSE PREVIEWS ON HOVER, A FINGER ON THE FIRST TAP: decided per
     pointer, not per device (29 Sep 2026: on the owner's touchscreen PC the
     browser reported "(hover: none)", so the desktop got the phone's two
     taps and hovering did nothing). Pointer events say which input is in
     use; a browser without them keeps the old media-query test. */
  var canHover = !window.matchMedia || window.matchMedia('(hover: hover)').matches;
  var usePointer = !!window.PointerEvent;
  var lastPointer = '';
  if (usePointer) {
    document.addEventListener('pointerover', function (e) {
      if (e.pointerType === 'mouse') show(e);
    });
    document.addEventListener(
      'pointerdown',
      function (e) {
        lastPointer = e.pointerType;
      },
      true
    );
  } else if (canHover) {
    document.addEventListener('mouseover', show);
  }
  document.addEventListener('focusin', show);

  /* TWO TAPS ON A PHONE, DELIBERATELY (owner, 20 Sep 2026: "on mobile if you
     click on that size it shows that size underneath ... so only double tab on
     the size selector so you can see the prices/sizes of the other variants").

     This used to be one tap, one page — a phone has no pointer, so previewing
     was thought to be impossible and the first tap simply opened the variant.
     That was the right call while the chip carried its own measurement. Now
     the measurement lives on the caption, so a shopper on a phone had no way
     to ask "what is the XL, and what does it cost" without loading the page
     and coming back.

     So the first tap on a size previews it — caption, price and the mark all
     move — and the second tap on the SAME size opens it. Tapping a different
     size moves the preview there instead. Nothing else on the card changes:
     the photo and the title still open the product on one tap, which is what
     most people will do.

     Only real pointer taps are intercepted. A keyboard Enter arrives with
     detail 0 and goes straight through, because focus has already previewed
     it — making someone press Enter twice would be a trap, not a preview.

     Only a finger or a pen gets the two taps (29 Sep 2026): a mouse click
     opens the size at once, as on any desktop, whatever the device claims. */
  if (usePointer || !canHover) {
    document.addEventListener(
      'click',
      function (e) {
        if (!e.detail) return;
        if (usePointer && lastPointer !== 'touch' && lastPointer !== 'pen') return;
        var hit = match(e.target);
        if (!hit || hit.kind !== '.ns-card-sizes__pill') return;
        if (hit.pill.getAttribute('data-ns-armed') === '1') return;

        e.preventDefault();
        var row = hit.pill.parentElement;
        if (row) {
          var armed = row.querySelectorAll('[data-ns-armed]');
          for (var i = 0; i < armed.length; i++) armed[i].removeAttribute('data-ns-armed');
        }
        hit.pill.setAttribute('data-ns-armed', '1');
        show(e);
      },
      true
    );
  }
})();
